export interface Review {
  reviewedDocumentId?: string;
  reviewedForId?: string;
  reviewedType?: string;
  message?: string;
  rating?: number;
  id: string;
  createdAt: string;
  updatedAt: string;
}

export function createReview(params: Partial<Review>) {
  return {} as Review;
}
